import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {SharedDataService} from '@signature-it/ngx-catalogue/services';
import {GenericConfig} from '@signature-it/ngx-generic/config';
declare let _: any;

@Component({
    selector: 'reset-filters',
    templateUrl: './reset-filters.component.html',
    styleUrls: ['./reset-filters.component.scss'],
    standalone: false
})

export class ResetFiltersComponent implements OnChanges{

    @Input() facets;
    filters : any;
    filtersKeys : any = [];
    hiddenFilters = GenericConfig.hiddenFilters || null;

    constructor(public sharedData: SharedDataService) {
    }

    ngOnChanges(changes: SimpleChanges) {
        const self = this;
        if(changes.facets && changes.facets.currentValue) {
            let obj = [];
            for(let key in this.facets) {
                if (!this.hiddenFilters || !this.hiddenFilters.includes(key)) {
                    if(_.isString(this.facets[key])) {
                        obj[key] = [this.facets[key]];
                    } else {
                        obj[key] = this.facets[key];
                    }
                }
            }
            this.filters = obj;
            if (this.hiddenFilters) {
                this.filtersKeys=[];
                this.filtersKeys = Object.keys(this.facets).filter(function(key){
                    if (!self.hiddenFilters.includes(key)){
                        return key;
                    }
                });
            }
            else{
                this.filtersKeys = Object.keys(this.facets);
            }
        }
    }

    reset(filterName, value) {
        let index =  this.filters[filterName].indexOf(value);
        this.filters[filterName].splice(index, 1);
        if(this.filters[filterName].length == 0) {
            delete this.filters[filterName];
        }
        this.sharedData.clickedFilter.next({fields: this.filters});
    }

    resetAll(event) {
        event.stopPropagation();
        this.sharedData.clickedFilter.next({fields: {}});
    }

}
